//useAuth 
import { useState, useEffect } from 'react';
import { auth } from '../config/firebase';
import { getDoc, doc } from 'firebase/firestore';
import { firestore } from '../config/firebase';
import { toast } from 'react-toastify';

const useAuth = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUser = async () => {
        const docRef = doc(firestore, "users", auth.currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setUser({id: docSnap.id, ...docSnap.data()})
        } else {
            console.error("User not found");
        }
    }

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                fetchUser();
                setLoading(false);
            } else {
                setUser(null);
            }
        });
    }, []);


    return { user, loading };
};

export default useAuth;